import { Inject, Injectable } from '@angular/core';

import * as Sentry from '@sentry/angular';

import { IMessagingEnvironment } from '../interfaces/IMessagingEnvironment';
import { MESSAGING_CONFIG } from '../messaging-config';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor(@Inject(MESSAGING_CONFIG) private readonly config: IMessagingEnvironment) {}

  debug(message: string, ...optionalParams: unknown[]): void {
    if (!this.config.production) {
      console.debug(message, ...optionalParams);
    }
  }

  info(message: string, ...optionalParams: unknown[]): void {
    if (!this.config.production) {
      console.info(message, ...optionalParams);
    }
  }

  warn(message: string, ...optionalParams: unknown[]): void {
    if (!this.config.production) {
      console.warn(message, ...optionalParams);
    }
  }

  error(error: unknown, context?: string): void {
    if (!this.config.production) {
      const prefix = context ? `[${context}] ` : '';
      console.error(prefix, error);
    }

    if (this.config.sentry.enabled) {
      Sentry.captureException(error, context ? { extra: { context } } : undefined);
    }
  }

  handleEffectError(error: unknown, context?: string): void {
    this.error(error, context ?? 'effect');
  }
}
